import { Chip } from "@mui/material";
import _ from "lodash";
import React from "react";

import { mediaDelete } from "../../../services/api/media.js";
import { models } from "../../../services/enums/index.js";
import { safeUpperCase } from "../../../services/utils/index.js";
import { PreviewButton } from "../../shared/buttons/index.js";
import { ItemFooter, ItemHeaderWithHighlight } from "../../shared/other/index.js";
import { ModelItemTemplate } from "../../shared/templates/index.js";
import { MediaPreviewDialog } from "../index.js";

export default ({
  item, highlight = [], callback, use,
}) => (
  <ModelItemTemplate
    inModal={_.isFunction(use)}
    header={<ItemHeaderWithHighlight name={item.name} highlight={highlight} />}
    footer={(
      <ItemFooter
        item={item}
        callback={callback}
        use={use}
        model={models.MEDIA}
        modelDelete={mediaDelete}
        buttons={<PreviewButton args={[item]} previewDialog={MediaPreviewDialog} />}
        chip={<Chip padding="0" color="secondary" size="small" label={safeUpperCase(item.file.mime)} />}
      />
)}
  />
);
